import React from 'react';
import {type SxProps, Typography} from '@mui/material';
import type {Environment} from 'configuration/types';
import {Configuration} from 'configuration';
import {FlexBox} from 'components';

type Props = {
  environment?: Environment;
};

const envBannerSx: SxProps = {
  transform: 'translateX(-30px) rotate(-45deg) scaleX(2) scaleY(1.5)',
  background: Configuration.env === 'stage' ? '#FF0C' : '#F00C',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  pointerEvents: 'none',
};

export const EnvironmentDisplay: React.FC<Props> = ({environment}) => {
  return environment !== 'prod' ? (
    <FlexBox position={'absolute'} center sx={envBannerSx}>
      <FlexBox center bottom>
        <Typography variant={'caption'}>
          {environment === 'stage'
            ? 'STG'
            : environment === 'dev'
              ? 'DEV'
              : 'LOCAL'}
        </Typography>
      </FlexBox>
    </FlexBox>
  ) : null;
};
